/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_SearchingInputs */



/**
* | output |
* | --- |
* | "Searching..." |
*
* @param {Explorer_Search_SearchingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_searching = /** @type {((inputs?: Explorer_Search_SearchingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_SearchingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Searching...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Searching...")
	return /** @type {LocalizedString} */ ("Searching...")
});